import request from "@/utils/request";
import base from './base';

// 删除原有的 host 定义
export const host = base.api_data;

const api_item = '/iteminfo/get_item_list/'; // 商品档案列表
const api_item_delete = '/iteminfo/get_item_delete/'; // 商品档案单条删除
const api_item_add = '/iteminfo/get_item_add/'; // 商品档案单条编辑
const api_itemcategory_list = '/iteminfo/get_itemcategory_list/'; // 商品分类列表
const api_category_tree = '/iteminfo/category_tree/'; // 商品类别分类树  （常用）

const api_store = '/store/get_store_list/'; // 门店信息列表
const api_region_tree = "/store/region_tree/"; //门店区域分组树 温州大区-温州一区  

//上传图片
// export const uploadUrl='/api//upload';
export default {
  //商品档案
  api_item(params) {
    return request.get(`${host}${api_item}`, { params });
  },
  api_item_delete(params) {
    return request.get(`${host}${api_item_delete}`, { params });
  },
  api_itemcategory_list(params) {
    return request.get(`${host}${api_itemcategory_list}`, { params });
  },
  api_item_add(params) {
    return request.get(`${host}${api_item_add}`, params);
  },
  api_category_tree(params) {
    return request.get(`${host}${api_category_tree}`, params);
  },
  //门店列表
  api_store(params) {
    console.log('fenye', params);
    return request.get(`${host}${api_store}`, { params });
  },
  //门店区域分组
  api_region_tree(params) {
    return request.get(`${host}${api_region_tree}`, params);
  },
};
